import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px",
  "data-kt-menu": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex flex-column bgi-no-repeat rounded-top",
  style: {"background-color":"#f2f4f6"}
}, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-black fw-bold px-9 mt-10 mb-6" }, "Notifications")
], -1)
const _hoisted_3 = { class: "tab-content" }
const _hoisted_4 = {
  class: "tab-pane fade show active",
  id: "kt_topbar_notifications_1",
  role: "tabpanel"
}
const _hoisted_5 = { class: "scroll-y mh-325px my-5 px-8" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = {
  class: "mb-0 me-2",
  style: {"margin-left":"10px"}
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "text-gray-400 fs-7 me-5" }
const _hoisted_10 = { class: "badge badge-light fs-8 m-2" }
const _hoisted_11 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "text-center border-top" }
const _hoisted_15 = { class: "svg-icon-svg-icon-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: _normalizeClass([
                'bg-gray-200',
                'd-flex',
                'flex-stack',
                'py-4',
                'mt-5',
                'rounded',
                { 'bg-white': item.isSeen },
              ])
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: ($event: any) => (_ctx.markAsRead(item)),
                    class: "fs-6 text-gray-800 text-hover-primary fw-bold"
                  }, _toDisplayString(item.title), 9, _hoisted_8),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(item?.body), 1)
                ])
              ]),
              _createElementVNode("span", _hoisted_10, _toDisplayString(item.createdat), 1)
            ], 2))
          }), 128)),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.page < _ctx.pageCount && _ctx.pageChanged())),
            href: "#",
            class: _normalizeClass(["btn btn-color-gray-600 btn-active-color-primary", { disabled: _ctx.page >= _ctx.pageCount }])
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.showMore() ? 'Load More' : ''), 1),
            _createElementVNode("span", _hoisted_15, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
            ])
          ], 2)
        ])
      ])
    ])
  ]))
}